import Url from "url-parse";
import { CDNWhiteList, ESTypes } from "../constants/constants.js";
import { prototypeToString, getSize } from "./tools.js";
import { ImageStandards } from "../constants/imageStandards.js";
import "./getDevicePixelRatio.js";
const PicCroppedExg = /![\S]*\.(jpg|jpeg|png|tiff|webp|gif|auto)/;
const isSupportFormat = (pathname) => {
  const PicFormatExg = /\/[\S]+\.(jpg|jpeg|png|tiff|webp|gif)/i;
  return PicFormatExg.test(pathname);
};
const getCroppedImageUrl = (originUrl, configs = {}) => {
  let _url = null;
  try {
    _url = new Url(originUrl);
  } catch (error) {
    return originUrl;
  }
  if (!CDNWhiteList.includes(_url.host)) {
    return originUrl;
  }
  if (PicCroppedExg.test(_url.pathname)) {
    return originUrl;
  }
  if (!isSupportFormat(_url.pathname)) {
    return originUrl;
  }
  let renderWidth = 0, renderHeight = 0, quality, devicePixelRatio;
  if (prototypeToString(configs) === ESTypes.string) {
    const standard = configs;
    if (ImageStandards[standard]) {
      ({ renderWidth = 0, renderHeight = 0, quality, devicePixelRatio } = ImageStandards[standard]);
    }
  }
  if (prototypeToString(configs) === ESTypes.object) {
    ({ renderWidth = 0, renderHeight = 0, quality, devicePixelRatio } = configs ?? {});
  }
  const _width = getSize(renderWidth, devicePixelRatio);
  const _height = getSize(renderHeight, devicePixelRatio);
  if (prototypeToString(quality) === ESTypes.number) {
    quality = quality < 0 ? void 0 : Math.floor(quality);
  }
  _url.set("pathname", `${_url.pathname}!c${_width}x${_height}${quality ? `_q${quality}` : ""}.auto`);
  return _url.toString();
};
export {
  getCroppedImageUrl
};
//# sourceMappingURL=getCroppedImageUrl.js.map
